<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE_MS = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // nicht reaktiv, je Komponenteninstanz
    this.timer = null;
    this.requestSeq = 0;
    this.geocoder = null;
    this.geocoderPromise = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.stopPending();
  },

  watch: {
    search(val) {
      if (!val || !String(val).trim()) {
        this.stopPending();
        this.items = [];
        return;
      }

      if (this.select && val === this.select.text) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Beendet Timer und laufende Anfrage und verwirft verspätete Antworten.
    stopPending() {
      this.requestSeq++;

      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.stopPending();

      const seq = this.requestSeq;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        this.geocoderPromise.then(geocoder => {
          if (seq !== this.requestSeq) {
            return null;
          }

          return geocoder.autocomplete(value);
        }).then(items => {
          if (seq !== this.requestSeq) {
            return;
          }

          this.items = Array.isArray(items) ? items.slice() : [];
        }).catch(() => {
          if (seq === this.requestSeq) {
            this.items = [];
          }
        }).finally(() => {
          if (seq === this.requestSeq) {
            this.loading = false;
          }
        });
      }, DEBOUNCE_MS);
    },

    change(o) {
      this.stopPending();
      this.$emit("change", o);
    }
  }
};
</script>
